import UrlBreakoutTableCard from './UrlBreakoutTableCard';

export default UrlBreakoutTableCard;
